import { authenticatedFetch } from './tokenUtils';

export async function generateLegalDocument(documentData, user) {
  const privacyData = documentData;
  const serviceLabels = {
    googleAnalytics: 'Google Analytics', firebaseAnalytics: 'Firebase Analytics', stripe: 'Stripe', paypal: 'PayPal',
    googleSignIn: 'Google Sign-In', facebookLogin: 'Facebook Login', appleSignIn: 'Apple Sign-In',
    firebaseCloudMessaging: 'Firebase Cloud Messaging', googleMaps: 'Google Maps', crashlytics: 'Firebase Crashlytics'
  };
  const services = Object.entries(serviceLabels)
    .filter(([key]) => documentData.thirdPartyServices?.[key])
    .map(([, name]) => ({ name }));
  const response = await authenticatedFetch('/api/privacy-policy/generate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...privacyData,
      extraDataFields: [
        ...(documentData.extraDataFields || []),
        ...(documentData.customDataTypes || []).filter(item => item.enabled).map(item => item.name)
      ],
      selectedThirdPartyServices: [
        ...(documentData.selectedThirdPartyServices || []),
        ...services
      ],
      documentType: documentData.documentType || 'privacy-policy',
      loginEmail: user?.email || documentData.loginEmail,
      paymentStatus: documentData.paymentStatus || 'pending'
    })
  });

  const result = await response.json();
  if (!response.ok) {
    throw new Error(result.errors?.join(', ') || result.message || 'Failed to generate document');
  }
  return result;
}
